<span class="field-tip password-pattern-info" [ngbTooltip]="PasswordPatternInfo" [placement]="placement" triggers="click:blur">
  <shared-ui-icons-icon [iconName]="iconType.CircleQuestion"></shared-ui-icons-icon>
</span>

<ng-template #PasswordPatternInfo>
  <h3>Your password should meet the following criteria to ensure it is strong and secure:</h3>
  <br />
  <p>1. <b>Length</b>. It must be between 8 and 16 characters long.</p>
  <p>2. <b>Character Variety</b>. It must include at least three of the following four types of characters:</p>
  <ul>
    <li>Lowercase letters (a-z)</li>
    <li>Uppercase letters (A-Z)</li>
    <li>Numbers (0-9)</li>
    <li>Special characters</li>
  </ul>
  <p>3. <b>Combination Requirements</b>. It should have:</p>
  <ul>
    <li>A mix of lowercase letters, uppercase letters, and numbers; <b>OR</b></li>
    <li>A mix of lowercase letters, uppercase letters, and special characters; <b>OR</b></li>
    <li>A mix of lowercase letters, numbers, and special characters; <b>OR</b></li>
    <li>A mix of uppercase letters, numbers, and special characters.</li>
  </ul>
</ng-template>
